import { render } from "./socialTab.vue?vue&type=template&id=b8295cce"
import script from "./socialTab.vue?vue&type=script&lang=js"
export * from "./socialTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__